export { isDesktop, isMobile, isTablet, isBrowser } from "react-device-detect";
